<div class="checkout-container">

  <!-- Summary Sidebar -->
  <!-- <aside class="summary-card">
    <h2>Parking Reservation</h2>
    
    <div class="lot-image">
      <img [src]="headerImage" [alt]="title" />
    </div>
    
    <div class="summary-section">
      <h3>{{ title }}</h3>
      <p>{{ lotOwner }}</p>
    </div>
    
    <div class="summary-section">
      <div class="row" *ngFor="let option of options">
        <span>{{ option.duration }}</span>
        <span>${{ option.flat_fee + option.rate | number:'1.2-2' }}</span>
      </div>
    </div>

    <div class="total">
      <span>Total</span>
      <strong>${{ getTotal() | number:'1.2-2' }}</strong>
    </div>
  </aside> -->

  @if (devMode)
  {
    <div class="dev-help">

      <p>data submitted? = {{ dataSubmitted | json}}</p>
      {{ submitData | json }}
      {{ sourceLandingPageId | json }}
    </div>
  }
  
  <!-- Main Checkout Form -->
  <main class="checkout-card">

    <h1>Parking Duration</h1>
  
    <div class="options">
      <label class="option" *ngFor="let option of options">
        <input
          type="radio"
          name="duration"
          [value]="option"
          [checked]="selectedOption?.id === option.id"
          (change)="selectOption(option)"
        />
<span>
  {{ option.duration_minutes && option.duration_minutes >= 60
    ? (option.duration_minutes / 60) + ' hr' + (option.duration_minutes === 60 ? '' : 's')
    : option.duration_minutes + ' minute' + (option.duration_minutes === 1 ? '' : 's')
  }}
  - ${{ option.flat_fee | number:'1.2-2' }}
</span>      </label>
    </div>
    @switch (selectedVehicleType)
    {
      @case('boat')
      {
        <h2>Boat Information</h2>

        <div class="field">
          <label>Boat Name</label>
          <input type="text" [(ngModel)]="boatName" placeholder="ABC1234" />
        </div>

        <div class="field">
          <label>Hull Number</label>
          <input type="text" [(ngModel)]="hullId" placeholder="ABC12345A606..." />
        </div>

        <div class="field">
          <label>Length (in feet)</label>
          <input type="text" [(ngModel)]="boatLength" placeholder="24" />
        </div>

        <div class="field">
          <label>Slip Number</label>
          <input type="text" [(ngModel)]="slipNumber" placeholder="A12" />
        </div>
      }
      @default 
      {
        <h2>Vehicle Information</h2>
        
        <div class="field">
          <label>License Plate</label>
          <input type="text" [(ngModel)]="licensePlate" placeholder="ABC1234" />
        </div>
        
        <div class="two-col">
          <div class="field">
            <label>Vehicle Make</label>
            <input type="text" [(ngModel)]="vehicleMake" placeholder="Toyota" />
          </div>
          <div class="field">
            <label>Color</label>
            <input type="text" [(ngModel)]="color" placeholder="White" />
          </div>
        </div>
        
        <div class="field">
          <label>Description</label>
          <textarea [(ngModel)]="vehicleDescription" rows="3" placeholder="SUV, roof rack, tinted windows"></textarea>
        </div>
      }
    }
      
<h2>Contact Information</h2>
  <div class="field">
    <label>Name</label>
    <input type="text" [(ngModel)]="customerName" placeholder="David Smith" />
  </div>

  <!-- <div class="field">
    <label>Email</label>
    <input type="email" [(ngModel)]="email" placeholder="you@example.com" />
  </div>

  <div class="field">
    <label>Phone Number</label>
    <input type="tel" [(ngModel)]="phoneNumber" placeholder="(555) 555-5555" />
  </div> -->

  <p class="info-note">Contact details are securely collected at checkout in case we need to reach you.</p>
    <button class="pay-button" [disabled]="!isFormValid()" (click)="onSubmit()">
      Pay ${{ getTotal() | number:'1.2-2' }}
    </button>

  </main>
</div>